import { useMutation } from '@tanstack/react-query';
import { ContactBodyType } from '@convergence/client';
import { fetch } from '../fetch';

export function contact(data: ContactBodyType & { captcha: string }) {
  const { captcha, ...rest } = data;
  return fetch('/payment/contact', {
    method: 'POST',
    body: JSON.stringify(rest),
    headers: {
      'x-captcha-token': captcha
    }
  });
}

export function useContactMutation() {
  return useMutation({
    mutationKey: ['contact'],
    retry: false,
    mutationFn: contact
  });
}

